var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('VueTrix', {
    staticClass: "s-trix-editor",
    attrs: {
      "input-name": _vm.name,
      "src-content": _vm.value,
      "placeholder": _vm.placeholder,
      "disabled-editor": _vm.readonly
    },
    on: {
      "update": function update($event) {
        return _vm.$emit('input', $event);
      },
      "trix-file-accept": _vm.handleFileAccept
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }